import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { newsActions } from '../actions/news.actions';
import { selectNews, selectNewsLoaded, selectNewsLoading } from '../selectors/news.selectors';

@Injectable({
    providedIn: 'root',
})
export class NewsFacade {
    private readonly store = inject(Store);

    readonly news = this.store.selectSignal(selectNews);
    readonly loading = this.store.selectSignal(selectNewsLoading);
    readonly loaded = this.store.selectSignal(selectNewsLoaded);

    getNews() {
        this.store.dispatch(newsActions.getNews());
    }

    clear() {
        this.store.dispatch(newsActions.clear());
    }
}
